export enum CETAClassroomStatus {
  Pending = 'Pending',
  Active = 'Active',
  Closed = 'Closed'
}
